<!--
    結果のサマリーカード
    @props img 顔画像
    @pros remark 一言
    @props description 長文コメント
-->
<template>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
    <div class="card">
      <div class="card-img-top center"  style="background: #ccc" >
          <img class="img-responsive" :src="$props.img" style="z-index: 2;"><br>
          <span class="card-title" style="z-index: 3;">{{ $props.remark }}</span>
      </div>
      <div class="card-body">
          <p>{{ $props.description }}</p>
      </div>

      <div class="card-footer">
          <a href="#" @click="$modal.show('modal-share')"
            v-text="$props.resultSummaryCard.modalShareButton"></a>
          <a href="#" @click="$modal.show('modal-introduce')" 
            v-text="$props.resultSummaryCard.modalIntroduceButton"></a>
      </div>
    </div>
    </div>
</template>

<script>
export default {
    props: [
        'img',
        'remark',
        'description',
        'resultSummaryCard'
    ],
}
</script>

<style>
    .card-title {
        font-size: 28px;
    }

    .center {
        text-align: center;
    }
</style>